/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Account_EmailInputs */

const en_consumer_declaration_account_email = /** @type {(inputs: Consumer_Declaration_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account email`)
};

const de_consumer_declaration_account_email = /** @type {(inputs: Consumer_Declaration_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto-E-Mail`)
};

const fr_consumer_declaration_account_email = /** @type {(inputs: Consumer_Declaration_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail du compte`)
};

const es_consumer_declaration_account_email = /** @type {(inputs: Consumer_Declaration_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo de la cuenta`)
};

const it_consumer_declaration_account_email = /** @type {(inputs: Consumer_Declaration_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail dell’account`)
};

const nl_consumer_declaration_account_email = /** @type {(inputs: Consumer_Declaration_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail van account`)
};

const pl_consumer_declaration_account_email = /** @type {(inputs: Consumer_Declaration_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail konta`)
};

const fi_consumer_declaration_account_email = /** @type {(inputs: Consumer_Declaration_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilin sähköposti`)
};

const da_consumer_declaration_account_email = /** @type {(inputs: Consumer_Declaration_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto-e-mail`)
};

const sv_consumer_declaration_account_email = /** @type {(inputs: Consumer_Declaration_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontots e-post`)
};

/**
* | output |
* | --- |
* | "Account email" |
*
* @param {Consumer_Declaration_Account_EmailInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_account_email = /** @type {((inputs?: Consumer_Declaration_Account_EmailInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Account_EmailInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_account_email(inputs)
	if (locale === "fr") return fr_consumer_declaration_account_email(inputs)
	if (locale === "es") return es_consumer_declaration_account_email(inputs)
	if (locale === "it") return it_consumer_declaration_account_email(inputs)
	if (locale === "nl") return nl_consumer_declaration_account_email(inputs)
	if (locale === "pl") return pl_consumer_declaration_account_email(inputs)
	if (locale === "fi") return fi_consumer_declaration_account_email(inputs)
	if (locale === "da") return da_consumer_declaration_account_email(inputs)
	if (locale === "sv") return sv_consumer_declaration_account_email(inputs)
	return en_consumer_declaration_account_email(inputs)
});